import * as store from "store";
import cookieStorage from "store/storages/cookieStorage";

export const userKey = "ttuser";
export const authRedirectKey = "ttredirect";
export const adoptionKey = "ttadoption";

export function getFromStorage<T>(key: string): T | undefined;
export function getFromStorage<T>(key: string, optionalDefaultValue: T): T;
export function getFromStorage<T>(key: string, optionalDefaultValue?: T) {
  return store.get(key, optionalDefaultValue) as T | undefined;
}

export function setInStorage<T>(key: string, data: T) {
  return store.set(key, data) as T;
}

export function setCookie(key: string, data: string, expDays = 1) {
  const date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();

  const host = location.host;
  if (host.split(".").length === 1) {
    document.cookie = key + "=" + data + "; " + expires + "; path=/";
  } else {
    const domainParts = host.split(".");
    domainParts.shift();
    const domain = "." + domainParts.join(".");
    document.cookie = key + "=" + data + "; " + expires + "; path=/; domain=" + domain;
  }
}

export function getCookie(key: string) {
  return cookieStorage.read(key);
}

export function removeFromStorage(key: string) {
  return store.remove(key);
}

export function removeCookie(key: string) {
  return cookieStorage.remove(key);
}
